"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _mobxUtils = require("mobx-utils");
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _constants2 = require("../constants");
var _user = require("../clients/user.client");
var _user2 = _interopRequireDefault(require("../factories/user.factory"));
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
/**
 * User Store
 */
let UserStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function UserStore(initialState = {}) {
    (0, _classCallCheck2.default)(this, UserStore);
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor2, this);
    /**
     * is loading
     * @return {boolean}
     */
    this.isLoading = (0, _mobxUtils.computedFn)(actionType => this.API_STATE[actionType] === _constants.API_STATE.LOADING);
    /**
     * is fetched
     * @return {boolean}
     */
    this.isFetched = (0, _mobxUtils.computedFn)(actionType => this.API_STATE[actionType] === _constants.API_STATE.SUCCESS);
    /**
     * has error
     * @return {boolean}
     */
    this.hasError = (0, _mobxUtils.computedFn)(actionType => this.API_STATE[actionType] === _constants.API_STATE.FAILED);
    /**
     * fetch user.me
     * @param {Function} errorHandler
     */
    (0, _initializerDefineProperty2.default)(this, "fetch", _descriptor3, this);
    /**
     *
     * @param {string} userId
     * @param {MyAccount.RawUser} user
     * @description update user
     */
    (0, _initializerDefineProperty2.default)(this, "update", _descriptor4, this);
    /**
     *
     * @param {payload.attachment}
     * @param {payload.fileName}
     * @description submit promo
     */
    (0, _initializerDefineProperty2.default)(this, "submitPromo", _descriptor5, this);
    this.updateInitialState(initialState);
  }
  (0, _createClass2.default)(UserStore, [{
    key: "user",
    get:
    /**
     * get user
     * @returns {{whatsapp, lastName, hasVerifiedWhatsApp, role, hasVerifiedPhone, hasVerifiedEmail, title, firstName, provider, phone, middleName, id, email}}
     */
    function () {
      return (0, _user2.default)(this.data);
    }

    /**
     * is User
     * @returns {boolean}
     */
  }, {
    key: "isUser",
    get: function () {
      return !!this.user.id;
    }

    /**
     *
     * @returns {boolean}
     */
  }, {
    key: "isVerifiedUser",
    get: function () {
      return this.data.accountStatus && (0, _toLower2.default)(this.data.accountStatus) === _constants2.ACCOUNT_STATUS.ACTIVE;
    }

    /**
     *
     * @returns {boolean}
     */
  }, {
    key: "isChangeEmailRequested",
    get: function () {
      return (0, _get2.default)(this.data, 'registrationRequest.email', false);
    }

    /**
     *
     * @returns {boolean}
     */
  }, {
    key: "referenceNumberFormatted",
    get: function () {
      return (0, _get2.default)(this.data, 'referenceNumberFormatted', '');
    }

    /**
     *
     * @returns {boolean}
     */
  }, {
    key: "isChangePhoneRequested",
    get: function () {
      return (0, _get2.default)(this.data, 'registrationRequest.phone.code', false);
    }

    /**
     *
     * @returns {*|boolean}
     */
  }, {
    key: "isSocialUserAccount",
    get: function () {
      return this.data.provider && this.data.provider !== _constants2.ACCOUNT_TYPE.LOCAL;
    }

    /**
     * string fursan identifier
     * @returns {string}
     */
  }, {
    key: "fursanIdentifier",
    get: function () {
      return (0, _get2.default)(this.data, 'loyalty.fursanNumber', '');
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param data
     * @param actionType
     */
    function onSuccess(data, actionType, successHandler) {
      this.data = data;
      this.API_STATE[actionType] = _constants.API_STATE.SUCCESS;
      successHandler && successHandler();
    }

    /**
     * handle error
     * @param error
     * @param errorHandler
     * @param actionType
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler, actionType) {
      errorHandler(error);
      this.API_STATE[actionType] = _constants.API_STATE.FAILED;
    }

    /**
     * set verified flag
     */
  }, {
    key: "setVerifiedFlag",
    value: function setVerifiedFlag() {
      this.data.accountStatus = _constants2.ACCOUNT_STATUS.ACTIVE;
    }

    /**
     * Reset Store
     */
  }, {
    key: "resetStore",
    value: function resetStore() {
      this.API_STATE[_constants2.ACTION_TYPES.UPDATE_USER] = _constants.API_STATE.INITIAL;
    }
  }]);
  return UserStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      [_constants2.ACTION_TYPES.FETCH_USER]: _constants.API_STATE.INITIAL,
      [_constants2.ACTION_TYPES.UPDATE_USER]: _constants.API_STATE.INITIAL,
      [_constants2.ACTION_TYPES.SUBMIT_PROMO]: _constants.API_STATE.INITIAL
    };
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isUser", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUser"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isVerifiedUser", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVerifiedUser"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isChangeEmailRequested", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isChangeEmailRequested"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "referenceNumberFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "referenceNumberFormatted"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isChangePhoneRequested", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isChangePhoneRequested"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSocialUserAccount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSocialUserAccount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fursanIdentifier", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "fursanIdentifier"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fetch", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* ({
      errorHandler = () => {},
      successHandler = () => {}
    }) {
      this.API_STATE[_constants2.ACTION_TYPES.FETCH_USER] = _constants.API_STATE.LOADING;
      try {
        const response = yield _user.UserClient.profile();
        this.onSuccess(response, _constants2.ACTION_TYPES.FETCH_USER, successHandler);
      } catch (error) {
        this.onError(error, errorHandler, _constants2.ACTION_TYPES.FETCH_USER);
      }
    });
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "update", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* ({
      userId,
      user,
      errorHandler = () => {},
      successHandler = () => {}
    }) {
      this.API_STATE[_constants2.ACTION_TYPES.UPDATE_USER] = _constants.API_STATE.LOADING;
      try {
        const response = yield _user.UserClient.updateProfile(userId, user);
        this.onSuccess(response, _constants2.ACTION_TYPES.UPDATE_USER, successHandler);
      } catch (error) {
        this.onError(error, errorHandler, _constants2.ACTION_TYPES.UPDATE_USER);
      }
    });
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "submitPromo", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* ({
      payload,
      errorHandler = () => {}
    }) {
      this.API_STATE[_constants2.ACTION_TYPES.SUBMIT_PROMO] = _constants.API_STATE.LOADING;
      try {
        const response = yield _user.UserClient.submitPromo(payload);
        this.onSuccess(response, _constants2.ACTION_TYPES.SUBMIT_PROMO);
      } catch (error) {
        this.onError(error, errorHandler, _constants2.ACTION_TYPES.SUBMIT_PROMO);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setVerifiedFlag", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setVerifiedFlag"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetStore", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetStore"), _class.prototype)), _class));
exports.default = UserStore;